<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': isMobile, 'mb16': !isMobile }">
            <Icon v-if="isMobile" name="arrow-left" class="c24 pointer" @click="close()"/>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': isMobile }">{{ this.user_pos == 'plaintiff' ? $t('views.P2P.RequestP2PArbitrage.1') : $t('views.P2P.RequestP2PArbitrage.6') }}</div>
            <Icon v-if="!isMobile" name="close" class="c24 pointer" @click="close()"/>
        </div>
        <div class="text-black bg-white rounded12" :class="{'arbitrage-container': this.user_pos == 'plaintiff', 'p24': !isMobile }">
            <div v-if="this.user_pos == 'plaintiff'" class="border-full p16 bg-light-grey rounded8 d-flex align-items-center mb24">
                <Icon name="info" class="c24 mr8" />
                <span class="fsp14 lh20 neue-roman">{{ $t('views.P2P.RequestP2PArbitrage.4') }}</span>
            </div>
            <div class="mb24 neue-roman">
                <GetInputs
                    v-if="this.fields.length"
                    :fields='this.fields' 
                    :no_visible_conditions="true"
                    :no_edit_conditions="true"
                    @updateParentState="this.updateState"
                />
            </div>
            <div class="d-flex justify-content-center gap-3 align-items-center" :class="{ 'mobile-modal-buttons': isMobile }">
                <Button 
                    class="equal-width h48"
                    :name="isMobile ? $t('views.P2P.RequestP2PArbitrage.3') : $t('views.P2P.RequestP2PArbitrage.5')" 
                    type="btn-warning"
                    :disabled="this.sendDisabled"
                    @click="this.user_pos == 'plaintiff' ? this.sendArbitrage() : this.agreeArbitrage()"
                />
                <Button 
                    class="equal-width h48"
                    :name="$t('views.P2P.RequestP2PArbitrage.2')" 
                    type="btn-outline-grey" 
                    @click="this.close"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import GetInputs from '@/components/service/GetInputs';
    import Button from '@/components/service/Button';
    import Icon from '@/components/icons/Icon';

    export default {
        components: {
            GetInputs,
            Button,
            Icon
        },
        props: {
            close: [Function],
        },
        data () {
            return {
                content: this.$store.state.modal.content,
                user_pos: this.$store.state.modal.content.userArbitragePos,
                fields: [],
                fields_values: {},
                required_fields: [],
                sendDisabled: true,
            }
        },
        computed: {
            isMobile() {
                return this.$store.state.resize.w <= 768;
            }
        },
        methods: {
            updateState(arg) {
                this.fields_values[arg.id] = arg.value;
                this.sendDisabled = this.checkRequiredFields();
            },
            checkRequiredFields() {
                let disabled = false;
                this.fields.forEach(field => {
                    const fieldId = field.alias;
                    if(field?.invalid || (!this.fields_values[fieldId] || this.fields_values[fieldId] == '-1') && field?.obligatory_conditions === '1') {
                        disabled = true;
                    }
                })

                return disabled;
            },
            getData() {
                let dataObject = {};
                dataObject.swap = this.content.dealCode;
                dataObject = {...dataObject, ...this.fields_values};
                return dataObject;
            },
            sendArbitrage() {
                if (!this.sendDisabled) {
                    // DELTA: disabled
                    // this.axios.post('RequestP2PArbitrage', {data: this.getData()}).then(res => {
                    //     if (res.data.body.result == '0') {
                    //         this.content.updateMessages();
                    //         this.close();
                    //     }
                    // });
                }
            },
            agreeArbitrage() {
                // DELTA: disabled
                // this.axios.post('AgreeP2PArbitrage', {data: this.getData()}).then(res => {
                //     if (res.data.body.result == '0') {
                //         this.content.updateMessages();
                //         this.close();
                //     }
                //
                // })
            },
            async loadFormFields() {
                try {
                    const forms = this.$store.state.userData?.forms;
                    console.log('forms', forms);
                    
                    if (!forms) {
                        return;
                    }

                    const formCode = this.user_pos == 'plaintiff' 
                        ? forms.arbitrage_plaintiff_from 
                        : forms.arbitrage_defendant_from;


                    const fieldsResponse = await this.axios.post('GetPublicFormFields', {no_loader: true, 
                        data: { code: formCode }
                    });

                    if (fieldsResponse.data.body.result == '0') {
                        this.fields = fieldsResponse.data.body.tables.fields.colvalues;
                    }    
                    
                    console.log('this.fields', this.fields);
                    console.log('Field structure:', this.fields.map(f => ({
                        name: f.name, 
                        visible: f.visible ? f.visible : f.visible_conditions, 
                        obligatory_conditions: f.obligatory_conditions
                    })));

                    this.required_fields = this.fields.filter(field => field.obligatory_conditions == '1');
                    this.sendDisabled = this.checkRequiredFields();

                } catch (error) {
                    console.error('Error loading form fields:', error);
                }
            },
        },
        created() {
            console.log('modal arbitrage user arb status', this.user_pos);
            this.loadFormFields();
        }
    }
</script>
